import React from "react";
import CustomLabel from "../shared/label/custom-label.component";
import { MdOutlineAdd } from "react-icons/md";
import { primaryOrange } from "../../constants/color";
import SectionTitle from "../section-title/section-title.component";
import SimpleGoogleAutocomplete from "../place-autocomplete/place-autocomplete.component";

const AddressSelection = ({
  selectedOption,
  addressList,
  showAddressInput,
  selectedAddress,
  handleAddressSelect,
  handleAddNewAddress,
  newAddress,
  setNewAddress,
  handleAddressChange,
  handleEditAddress,
  handleNext,
  editIndex,
  countryCode,
}) => {
  return (
    <div className="mt-4">
      {/* Show Address Section If Pick-Up or Pick-Up and Delivery is Selected */}
      {(selectedOption === "Pick-Up and Delivery" ||
        selectedOption === "Pick-Up") && (
        <div>
          <SectionTitle
            title={"Where should users pickup the product?"}
            subtitle={"We’ll inform your customer where to pickup the item(s)."}
          />

          {/* Address List with Selection */}
          {addressList?.length > 0 && (
            <ul style={{ listStyle: "none", padding: 0 }} className="mt-4">
              {addressList?.map((value, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    paddingBottom: "5px",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="radio"
                      name="selectedAddress"
                      value={value.address}
                      checked={selectedAddress === value.address || selectedAddress.address === value.address}
                      onClick={() => {
                        handleAddressSelect(value);
                      }}
                      style={{
                        fontSize: 16,
                        accentColor: primaryOrange, // Change the radio button color
                        cursor: "pointer",
                        transform: "scale(1.3)",
                      }}
                    />
                    {value.address}
                  </label>
                  <button
                    type="button" // Prevents form submission
                    onClick={() => handleEditAddress(index)}
                    style={{
                      color: "#FF6600",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      fontSize: 16,
                      fontWeight: "600",
                    }}
                  >
                    Edit
                  </button>
                </li>
              ))}
            </ul>
          )}

          {/* Add New Address Button (Limit to 2 Addresses) */}
          {!showAddressInput && addressList?.length < 2 && (
            <div
              style={{
                marginTop: "3%",
                display: "flex",
                flexDirection: "row",
              }}
              onClick={handleAddNewAddress}
            >
              <MdOutlineAdd color={primaryOrange} size={24} />
              <CustomLabel
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: primaryOrange,
                  marginLeft: "1%",
                }}
              >
                Add new address
              </CustomLabel>
            </div>
          )}

          {/* Address Input Field */}
          {showAddressInput && (
            <div style={{ marginTop: "10px" }}>
              <SimpleGoogleAutocomplete
                onSelect={(data) => {
                  handleAddressChange(data.address, null, null);
                  setNewAddress(data);
                }}
                countryCodes={countryCode}
                initialValue={newAddress}
              />
              <button
                onClick={handleNext}
                type="button" // Prevents form submission
                disabled={!newAddress?.address?.trim()}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#FF6600",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "12px",
                  marginTop: "2%",
                }}
              >
                {editIndex !== null ? "Update" : "Next"}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AddressSelection;
